/*
  The swap point. Today it re-exports the DOM implementations directly; when the native primitives
  land this becomes a conditional export in package.json ("react-native" → primitives.native, default
  → primitives.web) and this file goes away. Everything upstream imports from here, so the switch
  touches nothing else.
*/
export * from './primitives.types';
export * from './primitives.web';
